// src/helpers/register/printerCenter.ts
var formatParametersToGetPrintJob = (filterParams) => {
  const params = [];
  if (filterParams.printerId) {
    params.push(`printerId=${filterParams.printerId}`);
  }
  if (filterParams.status) {
    let statusArray = filterParams.status;
    if (!Array.isArray(filterParams.status)) {
      statusArray = [filterParams.status];
    }
    statusArray.forEach((status) => {
      params.push(`status=${status}`);
    });
  }
  if (filterParams.sortBy) {
    params.push(`sortBy=${filterParams.sortBy}`);
  }
  if (filterParams.sortDesc) {
    params.push(`sortDesc=${filterParams.sortDesc}`);
  }
  const formData = params.length > 0 ? `&${params.join("&")}` : "";
  return formData;
};

export { formatParametersToGetPrintJob };
